import { render, staticRenderFns } from "./BidsMobile.vue?vue&type=template&id=934cfc92&scoped=true&"
import script from "./BidsMobile.vue?vue&type=script&lang=js&"
export * from "./BidsMobile.vue?vue&type=script&lang=js&"
import style0 from "./BidsMobile.vue?vue&type=style&index=0&id=934cfc92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934cfc92",
  null
  
)

export default component.exports